module.exports = __webpack_public_path__ + "fonts/Caveat-VariableFont_wght.af4e1044.ttf";